import { apiClient } from "./client";
import type { CfoIncidentAction, CfoIncidentAttemptPage, CfoIncidentPage, CfoIncidentRead, CfoIncidentWorkPage, CfoWorkRead } from "./types";
const base = (slug: string) => `/projects/${slug}/cfo-workflow/incidents`;
export async function listCfoIncidents(slug: string, page = 1): Promise<CfoIncidentPage> {
  return (await apiClient.get<CfoIncidentPage>(base(slug), { params: { page, page_size: 20 } })).data;
}
export async function getCfoIncident(slug: string, id: string): Promise<CfoIncidentRead> {
  return (await apiClient.get<CfoIncidentRead>(`${base(slug)}/${id}`)).data;
}
export async function getCfoIncidentWork(slug: string, id: string, page = 1): Promise<CfoIncidentWorkPage> {
  return (await apiClient.get<CfoIncidentWorkPage>(`${base(slug)}/${id}/work-items`, { params: { page } })).data;
}
export async function getCfoIncidentAttempts(slug: string, id: string, page = 1): Promise<CfoIncidentAttemptPage> {
  return (await apiClient.get<CfoIncidentAttemptPage>(`${base(slug)}/${id}/attempts`, { params: { page } })).data;
}
export async function requestCfoIncidentAction(slug: string, id: string, request: CfoIncidentAction): Promise<CfoWorkRead> {
  return (await apiClient.post<CfoWorkRead>(`${base(slug)}/${id}/actions`, request)).data;
}
